"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeOutcomesDiff = computeOutcomesDiff;
const getCategoryMarketInfoFilteredTradingStatus_1 = require("../getCategoryMarketInfoFilteredTradingStatus");
const groupEventProbabilities_1 = require("./groupEventProbabilities");
const findChanges_1 = require("./findChanges");
const mapProbsToOutcomes_1 = require("./mapProbsToOutcomes");
const updateOutcome_1 = require("./updateOutcome");
const getOrderedOutcomeKeys_1 = require("./getOrderedOutcomeKeys");
function marketChanged(changesDraft) {
    return (changesDraft.changedOrder !== undefined ||
        changesDraft.statusChanged ||
        Object.keys(changesDraft.changedOutcomes).length > 0 ||
        changesDraft.deletedOutcomesKeys !== undefined);
}
function computeOutcomesDiff(args) {
    const { prevOutcomes, eventMarkets, eventStatus, sportId, clientType, eventCompetitors, marketsMap, vCategoriesInfo, vCategoriesSortedIds, vMarketsInfo, playersMap, forcePlayersUpdate, probsWithPlayerIdParam = {}, } = args;
    const grouped = (0, groupEventProbabilities_1.groupEventProbabilities)(eventMarkets, vMarketsInfo, vCategoriesInfo, sportId, playersMap, probsWithPlayerIdParam);
    const changes = (0, findChanges_1.findChanges)(grouped, prevOutcomes, vCategoriesInfo, vCategoriesSortedIds, forcePlayersUpdate, probsWithPlayerIdParam);
    const tempNewMarkets = {};
    const tempMarketsUpdates = {};
    // Проверяем все изменения по маркетам
    Object.entries(changes.marketsChanges).forEach(([vMarketId, marketChanges]) => {
        var _a, _b, _c, _d;
        const { newProbabilities, changedProbabilities, deletedKeys } = marketChanges;
        const tempMarketUpdates = {
            changedOutcomes: {},
            statusChanged: false,
        };
        const prevOutcomesByKeys = (_b = (_a = prevOutcomes.markets[vMarketId]) === null || _a === void 0 ? void 0 : _a.outcomesByKey) !== null && _b !== void 0 ? _b : {};
        const vMarketInfo = vMarketsInfo[vMarketId];
        const { vCategoryId } = vMarketInfo;
        const { marketId } = vMarketInfo.filteredBy;
        const orderedOutcomeTypes = (_d = (_c = marketsMap[marketId]) === null || _c === void 0 ? void 0 : _c.orderedOutcomeTypes) !== null && _d !== void 0 ? _d : [];
        let needUpdateOrder = false;
        let needRecalculateStatus = false;
        let draft = { ...prevOutcomesByKeys };
        if (deletedKeys.size > 0) {
            needUpdateOrder = true;
            needRecalculateStatus = true;
            tempMarketUpdates.deletedOutcomesKeys = new Set();
            Object.keys(draft).forEach((outcomeKey) => {
                var _a;
                if (deletedKeys.has(outcomeKey)) {
                    delete draft[outcomeKey];
                    (_a = tempMarketUpdates.deletedOutcomesKeys) === null || _a === void 0 ? void 0 : _a.add(outcomeKey);
                }
            });
        }
        if (Object.keys(changedProbabilities).length > 0) {
            needRecalculateStatus = true;
            Object.entries(changedProbabilities).forEach(([outcomeKey, probability]) => {
                const oldOutcome = prevOutcomes.markets[vMarketId].outcomesByKey[outcomeKey];
                const updatedOutcome = (0, updateOutcome_1.updateOutcome)(oldOutcome, probability);
                draft[outcomeKey] = updatedOutcome;
                tempMarketUpdates.changedOutcomes[outcomeKey] = updatedOutcome;
            });
        }
        if (Object.keys(newProbabilities).length > 0) {
            const newOutcomes = (0, mapProbsToOutcomes_1.mapProbabilitiesToOutcomes)({
                probabilities: newProbabilities,
                vMarketInfo,
                orderedOutcomeTypes,
                players: playersMap,
                eventCompetitors,
                clientType,
            });
            if (Object.keys(newOutcomes).length > 0) {
                needUpdateOrder = true;
                needRecalculateStatus = true;
                draft = { ...draft, ...newOutcomes };
                tempMarketUpdates.changedOutcomes = {
                    ...tempMarketUpdates.changedOutcomes,
                    ...newOutcomes,
                };
            }
        }
        if (prevOutcomes.markets[vMarketId] === undefined) {
            tempNewMarkets[vMarketId] = {
                vCategoryId,
                vMarketId,
                outcomesByKey: draft,
                outcomesOrder: (0, getOrderedOutcomeKeys_1.getOrderedOutcomeKeys)({
                    vMarketInfo,
                    orderedOutcomeTypes,
                    outcomes: draft,
                }),
                tradingStatus: (0, getCategoryMarketInfoFilteredTradingStatus_1.getOutcomesMarketTradingStatus)({
                    outcomes: Object.values(draft),
                    eventStatus,
                }),
            };
        }
        else {
            if (needUpdateOrder) {
                tempMarketUpdates.changedOrder = (0, getOrderedOutcomeKeys_1.getOrderedOutcomeKeys)({
                    vMarketInfo,
                    orderedOutcomeTypes,
                    outcomes: draft,
                });
            }
            if (needRecalculateStatus) {
                const newStatus = (0, getCategoryMarketInfoFilteredTradingStatus_1.getOutcomesMarketTradingStatus)({
                    outcomes: Object.values(draft),
                    eventStatus,
                });
                const statusChanged = newStatus !== prevOutcomes.markets[vMarketId].tradingStatus;
                if (statusChanged) {
                    tempMarketUpdates.statusChanged = true;
                    tempMarketUpdates.changedTradingStatus = newStatus;
                }
            }
            if (marketChanged(tempMarketUpdates)) {
                tempMarketsUpdates[vMarketId] = tempMarketUpdates;
            }
        }
    });
    if (Object.keys(tempNewMarkets).length === 0 &&
        Object.keys(tempMarketsUpdates).length === 0 &&
        changes.deletedMarkets.size === 0 &&
        changes.changedCategories === undefined) {
        return null;
    }
    return {
        newMarkets: tempNewMarkets,
        changedMarkets: tempMarketsUpdates,
        deletedMarketsIds: changes.deletedMarkets,
        changedCategories: changes.changedCategories,
    };
}
//# sourceMappingURL=computeOutcomes.js.map